import { Link, useLocation } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import useSeo from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面不存在 - 404',
    description: '你访问的页面不存在或已被调整，返回看瓜爆料首页查看最新独家爆料。',
    path: location.pathname,
  });

  return (
    <SiteLayout>
      <section className="mx-auto flex max-w-content flex-col items-center px-4 py-24 text-center md:px-6 md:py-32">
        <span
          className="font-brand text-7xl leading-none text-primary-200 md:text-9xl"
          aria-hidden="true"
        >
          404
        </span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这条瓜没挖到
        </h1>
        <p className="mt-3 max-w-md text-sm text-foreground-600">
          你访问的页面不存在或已经调整。返回首页，看看今天最值得看的爆料。
        </p>
        <p className="mt-2 font-mono text-xs text-foreground-400">{location.pathname}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/topics"
            className="whitespace-nowrap rounded-full border border-background-300/70 bg-background-100/60 px-6 py-3 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            进入爆料库
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}